export const COMMUNICATION_TYPES = {
    ANNOUNCEMENT: 'announcement',
    SMS: 'sms',
    CAMPAIGN: 'campaign',
    QUESTIONNAIRE: 'questionnaire',
  }
  
  export const STATUSES = {
    ACTIVE: 'active',
    EXPIRED: 'expired',
    DRAFT: 'draft',
  }
  